import { lazy } from "react"

// settings模块子页面
export const Address = lazy(
  () => import("@/pages/Setting/components/Address/index"),
)
export const Integration = lazy(
  () => import("@/pages/Setting/components/Integration/index"),
)
export const IntegrationShipping = lazy(
  () => import("@/pages/Setting/components/IntegrationShipping/index"),
)
export const IntegrationSendCloud = lazy(
  () => import("@/pages/Setting/components/IntegrationSendCloud/index"),
)
export const IntegrationFedex = lazy(
  () => import("@/pages/Setting/components/IntegrationFedex/index"),
)
export const IntegrationShipStation = lazy(
  () => import("@/pages/Setting/components/IntegrationShipStation/index"),
)
export const IntegrationDHL = lazy(
  () => import("@/pages/Setting/components/IntegrationDHL/index"),
)
export const IntegrationDhlExpress = lazy(
  () => import("@/pages/Setting/components/IntegrationDhlExpress/index"),
)
export const IntegrationShiprocket = lazy(
  () => import("@/pages/Setting/components/IntegrationShiprocket/index"),
)
export const IntegrationSendle = lazy(
  () => import("@/pages/Setting/components/IntegrationSendle/index"),
)
export const MethodForm = lazy(
  () => import("@/pages/Setting/components/MethodForm/index"),
)
export const Reason = lazy(
  () => import("@/pages/Setting/components/Reason/index"),
)
export const RulesForm = lazy(
  () => import("@/pages/Setting/components/RulesForm/index"),
)
export const RulesFormBlockList = lazy(
  () => import("@/pages/Setting/components/RulesForm/RulesFormBlockList"),
)
export const SolutionForm = lazy(
  () => import("@/pages/Setting/components/SolutionForm/index"),
)
export const AddReason = lazy(
  () => import("@/pages/Setting/components/AddReason/index"),
)
export const ReasonGroup = lazy(
  () => import("@/pages/Setting/components/ReasonGroup/index"),
)
export const Automation = lazy(
  () => import("@/pages/Setting/components/Automation/index"),
)

export const AutomationFailTable = lazy(
  () =>
    import("@/pages/Setting/components/Automation/component/AutomationFailTable"),
)

export const IntegrationGls = lazy(
  () => import("@/pages/Setting/components/IntegrationGls/index"),
)

export const IntegrationPacketa = lazy(
  () => import("@/pages/Setting/components/IntegrationPacketa/index"),
)

export const AddFunds = lazy(
  () => import("@/pages/Setting/components/AddFunds/index"),
)

export const LabelHistory = lazy(
  () => import("@/pages/Setting/components/LabelHistory"),
)

export const RechargeRecords = lazy(
  () => import("@/pages/Setting/components/RechargeRecords"),
)

export const PreferredLanguage = lazy(
  () => import("@/pages/Setting/components/PreferredLanguage/index"),
)
